<script setup lang="ts">
import InformationContainer from '@components/ui/auto-reserve&gift-card&index/InformationContainer.vue';
import { ReserveType } from '@utils/itinerary';

const { setReserveType } = useSearchFormStore();
useServerHead({
    link: [
        {
            rel: 'canonical',
            href: 'https://mrbilit.com/bus-ticket',
        },
    ],
});
definePageMeta({
    breadcrumbs: JSON.stringify([
        { title: 'مِستربلیط', link: '/' },
        { title: 'بلیط اتوبوس', link: '/bus-ticket' },
    ]),
});
onMounted(() => setReserveType(ReserveType.Bus));
</script>
<template>
    <InformationContainer />
</template>
<style scoped lang="scss">
.wrapper {
    background: white;
}

h2 {
    font-style: normal;
    @include font-weight(bold);
    font-size: 20px;
    line-height: 31px;
    text-align: right;
    color: usePalette($p-cool-gray, $p-800);
    margin-bottom: 24px;
}

.logo-container {
    background-color: usePalette($p-blue, $p-100);
    padding: 48px 0 106px 0;
}

:deep(.logo) {
    min-height: unset;
    width: 288px !important;
}

@media (max-width: $app-mobile-max-width) {
    h2 {
        font-style: normal !important;
        @include font-weight(bold, $important: true);
        font-size: 20px !important;
        line-height: 31px !important;
        color: usePalette($p-cool-gray, $p-800) !important;
        margin-bottom: 24px !important;
        text-align: center !important;
    }
}
</style>
